import { render, staticRenderFns } from "./ValidResult.vue?vue&type=template&id=328e2eb6&"
import script from "./ValidResult.vue?vue&type=script&lang=js&"
export * from "./ValidResult.vue?vue&type=script&lang=js&"
import style0 from "./ValidResult.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports